export const downloadFileFromDataURL = (dataURL, fileName) => {
  // Create a temporary anchor element
  const anchor = document.createElement("a");
  anchor.href = dataURL;
  anchor.download = fileName;

  // Programmatically click the anchor element to initiate download
  anchor.click();

  // Clean up: remove the anchor element
  anchor.remove();
};

export const isJSONParsable = (strValue) => {
  try {
    JSON.parse(strValue);
  } catch (e) {
    return false;
  }

  return true;
};

export const HighlightText = ({ text = "", highlight = "" }) => {
  if (!highlight.trim()) {
    return <span>{text}</span>;
  }
  const regex = new RegExp(`(${highlight})`, "gi");
  const parts = text.split(regex);

  return (
    <span>
      {parts.filter(String).map((part, i) => {
        return regex.test(part) ? (
          <mark key={i}>{part}</mark>
        ) : (
          <span key={i}>{part}</span>
        );
      })}
    </span>
  );
};
